



































































































































































































































































































import Vue from 'vue';

import LoadProject from '../components/LoadProject.vue';
import LoadImage from '../components/LoadImage.vue';

export default Vue.extend({
  components: {
    LoadProject,
    LoadImage,
  },
  props: ['projectPass'],
  mounted() {
    setTimeout(() => {
      this.show = true;
      this.getWindowWidth();
      window.addEventListener('resize', this.getWindowWidth, false);
      window.addEventListener('hashchange', this.hashChange, false);
      window.location.hash = `/${this.projectPass.name}`;
      setTimeout(() => {
        this.eleTop = this.$el.querySelector('.js-elementTop').offsetTop;
        this.stickInfo();
      }, 1000);
    }, 1500);
  },
  methods: {
    hideProject() {
      this.$emit('projectHide');
    },
    hashChange() {
      if (window.location.hash === '') {
        this.$emit('projectHide');
      }
    },
    toTop() {
      if (window.scrollY !== 0) {
        setTimeout(() => {
          window.scrollTo(0, window.scrollY - 100);
          this.toTop();
        }, 10);
      }
    },
    getWindowWidth() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768) {
        this.isPhone = true;
        this.isFixed = false;
      } else {
        this.isPhone = false;
      }
    },
    stickInfo() {
      window.addEventListener('scroll', () => {
        if (!this.isPhone) {
          if (!this.isFixed && this.eleTop - window.scrollY < 0) {
            this.isFixed = true;
          } else if (this.isFixed && window.scrollY < this.eleTop) {
            this.isFixed = false;
          }
        } else {
          this.isFixed = false;
        }
      });
    },
    loadImageSend(src) {
      this.loadImageSrc = src;
      this.loadImageShow = true;
    },
    loadImageHide() {
      this.loadImageShow = false;
      this.loadImageSrc = '';
    },
  },
  data() {
    return {
      loading: true,
      projectSelected: false,
      show: false,
      isFixed: false,
      windowWidth: 0,
      isPhone: false,
      eleTop: 0,
      loadImageShow: false,
      loadImageSrc: '',
    };
  },
});
